import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/admin/services")({
  beforeLoad: () => {
    throw redirect({
      to: "/dashboard/admin/catalog",
      search: { tab: "services" },
    });
  },
});
